module.exports = __webpack_public_path__ + "static/media/chi-logo.2ce0389b.png";